<template>
  <v-container>

    <v-card-title class="" style="color:#AF8936">
      <h2>COMUNICADOS</h2>
    </v-card-title>

    <v-card flat>
      <v-divider></v-divider>
      <h3 style="color:#0A4A79" class="mt-3 ml-3">Filtros</h3>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="no_toca"
              label="Toca"
              prepend-icon="mdi-folder-outline"
              clearable
              outlined
              dense
              hint="Ej. 1/2024"
              @click="status=''"
              v-on:keyup.enter="clickSearch()"
            >
              <v-btn
                slot="append"
                outlined
                fab
                x-small
                color="#607D8B"
                @click='clickSearch()'
                style="margin-top: -3px;"
              ><v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              :items="listStatus"
              v-model="status"
              @click="no_toca=''"
              label="Estatus"
              prepend-icon="mdi-file-alert-outline"
              item-value="id"
              item-text="nombre"
              outlined
              dense
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-title  style="color:#0A4A79">
        <h4>{{ titleTabla }}</h4>
        <h4 class="ml-1">({{ total_comunicados }})</h4>
      </v-card-title>

      <v-data-table
        dense
        align="left"
        :loading="loadingTable"
        :headers="headers"
        :items="listOrderComunicados"
        item-key="id"
        :page.sync="page"
        :items-per-page="per_page_table"
        hide-default-footer
        no-data-text="No se Encontraron Registros"
      >
        <template v-slot:item.toca="{ item }">
          <span v-if="item">
            <b>{{ item.apelacion.toca.numero}}/{{ item.apelacion.toca.anio}}</b>
          </span>
        </template>
        <template v-slot:item.tipo_envio="{ item }">
          <span v-if="item.tipo_envio_id == 1"><b>Requerimiento</b></span>
          <span v-if="item.tipo_envio_id == 2"><b>Comunicado</b></span>
        </template>
        <template v-slot:item.status="{ item }">
          <div v-if="item.vista_juez == 2">
            <span style="color:red;font-weight:bold;">Pendiente de envío</span>
          </div>
          <div v-if="item.vista_juez == 1 && item.e_envio.contesto == null">
            <span style="color:;font-weight:bold;">Enviado</span>
          </div>
          <div v-if="item.vista_juez == 1 && item.contesto == 2">
            <span style="color:;font-weight:bold;">No Contestado</span>
          </div>
          <div v-if="item.vista_juez == 1 && item.e_envio.contesto == 1">
            <span style="color:green;font-weight:bold;">Contestado por Juzgado</span>
          </div>
          <div v-if="item.status == 1">
            <span style="color:#149e0f;font-weight:bold;">Recibido y Subsanado</span>
          </div>
          <div v-if="item.status == 2">
            <span style="color:#dfa019;font-weight:bold;">Recibido y No Subsanado</span>
          </div>
        </template>
        <template v-slot:item.fechas="{ item }" >
          <span>{{item.created_at | formatDate}}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="text-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mt-n1"
                  color="primary"
                  dark
                  x-small
                  v-bind="attrs"
                  v-on="on"
                >
                <v-icon small dark left>mdi-cog</v-icon>
                  Acciones
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="showComunicado(item)">
                  <v-list-item-icon class="justify-center mx-2">
                    <v-icon>mdi-file</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Ver Comunicado </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.e_envio && item.e_envio.contesto == null"
                  @click="noContesto(item)"
                >
                  <v-list-item-icon class="justify-center mx-2">
                    <v-icon>mdi-close</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>No Contestó</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.e_envio && item.e_envio.contesto == 1 && item.contesto != 1"
                  @click="aceptarSubsanada(item)"
                >
                  <v-list-item-icon class="justify-center mx-2">
                    <v-icon>mdi-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Recibí y Subsano</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.e_envio && item.e_envio.contesto == 1 && item.contesto != 1"
                  @click="noSubsano(item)"
                >
                  <v-list-item-icon class="justify-center mx-2">
                    <v-icon>mdi-file-alert-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Recibí y NO Subsano</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination
          v-if="pagination.total > 1"
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="7"
          @input="onPageChange"
          color="blue"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        ></v-pagination>
      </div>

    </v-card>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import _ from 'lodash';

  import { mapGetters } from 'vuex'
  export default {
    data: () => ({
      page: 1,
      per_page_table: 20,
      pagination: {
        current: 1,
        total: 0
      },
      total_comunicados: 0,
      loading:false,
      status:'',
      no_toca: '',
      titleTabla: 'REGISTROS',
      listComunicados: [],
      comunicados: [],
      loadingTable: false,
      headers: [
        { text: 'Toca', value: 'toca' },
        { text: 'Fecha creado', value: 'fechas' },
        { text: 'Num. Oficio', value: 'num_oficio' },
        { text: 'Estatus del Comunicado', value: 'status', sortable: false },
        { text: 'Tipo Envío', value: 'tipo_envio', sortable: false },
        { text: '', value:'action' },
      ],
      listStatus:[
        { id: 10, nombre: 'Pendiente de Envío' },
        { id: 20, nombre: 'Enviado' },
        { id: 30, nombre: 'Recibidos' },
        { id: 40, nombre: 'No Cumplio' }
      ]
    }),
    computed: {
      ...mapGetters(["roleUser", "currentUser"]),
      listOrderComunicados: function () {
        return _.orderBy(this.listComunicados, 'e_envio.contesto', 'asc')
      }
    },
    watch: {
      status: function (val) {
        this.pagination.current = 1;
        this.getListComunicados()
      },
    },
    mounted(){
      this.status = 20;
      this.getListComunicados()
    },
    methods: {
      clickSearch(){
        this.titleTabla = 'RESULTADO DE LA BUSQUEDA'
        this.loadingTable = true
        this.getListComunicados()
      },
      onPageChange() {
        this.getListComunicados();
      },
      getListComunicados() {
        this.loadingTable = true
        this.listComunicados = []
        this.$store.dispatch("GET_CATEGORIAS", {
            url:"/envios?page="+this.pagination.current,
            params: {
              status:this.status,
              no_toca:this.no_toca
            }
          }).then((response) => {
            this.loadingTable = false
            this.pagination.current = response.data.data.envios.current_page;
            this.pagination.total = response.data.data.envios.last_page;
            this.per_page_table = response.data.data.envios.per_page;
            this.total_comunicados = response.data.data.envios.total;
            this.listComunicados = response.data.data.envios.data;
            // if(this.status == 30){
            //   this.comunicados = [];
            //   this.listComunicados.forEach(envios => {
            //     if(envios.e_envio != null)
            //       this.comunicados.push(envios);
            //   })
            //   this.listComunicados = this.comunicados;
            // }
          }).catch(err => {
            console.log(err);
          });
      },
      noContesto(item){
        console.log(item)
        Swal.fire({
          title: '¿Confirma marcar como NO CONTESTÓ?',
          html: "<span style='color:red; font-weight: 800;'>Esta acción no se puede deshacer<span style='color:red; font-weight: 800;'>",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        })
        .then((result) => {
          if (result.value) {

        this.$store.dispatch("UPDATE_APELACION", { url: "/no-contesto",
          data:{
            e_apelacion_id: item.e_apelacion_id,
            e_envio_id: item.e_envio_id,
            apelacion_id: item.apelacion_id,
            envio_id:item.id,
          }
        })
            .then(response => {
              Swal.fire({
                icon: 'success',
                title: 'Se ha marcado como NO CONTESTÓ!',
                confirmButtonText: "Aceptar"
              })
              this.getListComunicados()

            }).catch(err => {
              console.log(err);
            });
          }
        })
      },
      aceptarSubsanada(item){
        Swal.fire({
          title: '¿Confirma Aceptar Comunicado?',
          html: "<span style='color:red; font-weight: 800;'>Esta acción no se puede deshacer<span style='color:red; font-weight: 800;'>",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("UPDATE_APELACION", { url: "/aceptar",
              data:{
                e_apelacion_id: item.e_apelacion_id,
                e_envio_id: item.e_envio_id,
                apelacion_id: item.apelacion_id,
                envio_id:item.id,
              }
            }).then(response => {
              Swal.fire({
                icon: 'success',
                title: 'Contestación recibida.',
                confirmButtonText: "Aceptar"
              })
              this.getListComunicados()
            }).catch(err => {
              console.log(err);
            });
          }
        })
      },
      noSubsano(item){
        // console.log(item)
        Swal.fire({
          title: '¿Confirma Aceptar comunicado y marcar como No subsano?',
          html: "<span style='color:red; font-weight: 800;'>Esta acción no se puede deshacer<span style='color:red; font-weight: 800;'>",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar"
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("UPDATE_APELACION", { url: "/no-subsano",
              data:{
                e_apelacion_id: item.e_apelacion_id,
                e_envio_id: item.e_envio_id,
                apelacion_id: item.apelacion_id,
                envio_id:item.id,
              }
            }).then(response => {
              Swal.fire({
                icon: 'success',
                title: 'Contestación recibida.',
                confirmButtonText: "Aceptar"
              })
              this.getListComunicados()
            }).catch(err => {
              console.log(err);
            });
          }
        })
      },
      close() {
        this.paginationHistorial.current = 1
      },
      showComunicado(item){
        localStorage.setItem("currentApelacion", JSON.stringify( item.apelacion_id ));
        this.$router.push({name: 'Comunicados'});
      },
    }
  };
</script>
